
const drawer = document.getElementById("cartDrawer");
const overlay = document.getElementById("cartOverlay");
const container = document.getElementById("cartDrawerItems");

let isUpdating = false;
let updateTimeout;
let cartDrawerOpener = null;

function openCartDrawer(opener = document.activeElement) {
  const drawerEl = document.getElementById("cartDrawer");
  const overlayEl = document.getElementById("cartOverlay");

  if (!drawerEl || !overlayEl) return;

  if (opener instanceof HTMLElement && !drawerEl.contains(opener)) {
    cartDrawerOpener = opener;
  }

  drawerEl.removeAttribute("inert");
  drawerEl.setAttribute("aria-hidden", "false");
  drawerEl.classList.remove("translate-x-full");

  overlayEl.classList.remove("hidden");
  document.body.classList.add("overflow-hidden");

  document
    .querySelectorAll('[aria-controls="cartDrawer"]')
    .forEach((trigger) => trigger.setAttribute("aria-expanded", "true"));

  const msg = document.getElementById("couponMessage");

  if (msg) {
    msg.textContent = "";
    msg.classList.add("hidden");
  }

  requestAnimationFrame(() => {
    document.getElementById("cartDrawerCountTitle")?.focus({
      preventScroll: true,
    });
  });
}

async function removeCoupon() {
  try {
    // 🔥 Show loader instantly
    showCartLoader();

    // Optional: disable remove button instantly (feels responsive)
    const btn = document.querySelector("#couponInputWrapper button");
    if (btn) {
      btn.disabled = true;
      btn.innerText = "Removing...";
    }

    // 🔥 Actual removal
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: '' })
    });

    // 🔥 Reload cart → updates UI + price
    await loadCartDrawer(true);

  } catch (err) {
    console.error("❌ Failed to remove coupon", err);
  } finally {
    // 🔥 Always hide loader
    hideCartLoader();
  }
}

function showCouponApplied(code, savings) {
  const couponBox = document.getElementById("couponInputWrapper");
  if (!couponBox) return; // 👈 guard
  couponBox.innerHTML = `
    <div class="flex items-center justify-between px-4 py-2.5 border border-green-400 rounded-[10px] bg-green-50">
      <div class="flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#16a34a" viewBox="0 0 256 256">
          <path d="M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34Z"/>
        </svg>
        <span class="text-[13px] font-black text-green-700">${code}</span>
        <span class="text-[12px] text-green-600 font-medium">— You save ${savings}</span>
      </div>
      <button onclick="removeCoupon()" class="text-[11px] font-bold text-black hover:bg-gray-800 hover:text-white transition px-2 py-1 rounded">
        Remove
      </button>
    </div>
  `;
}
function attachCouponListener() {
  document.getElementById("applyCouponBtn")?.addEventListener("click", handleCouponApply);
}

async function handleCouponApply() {
  const code = document.getElementById("couponInput")?.value?.trim();
  const msg = document.getElementById("couponMessage");
  if (!code) return;

  const applyBtn = document.getElementById("applyCouponBtn");
  applyBtn.innerText = "Applying...";
  applyBtn.disabled = true;

  try {
    await fetch("/discount/" + encodeURIComponent(code), { method: "GET" });
    const cartRes = await fetch("/cart.js");
    const cart = await cartRes.json();

    const applied = cart.cart_level_discount_applications?.find(
      d => d.title?.toUpperCase() === code.toUpperCase()
    );

    const hasLineDiscount = cart.items.some(item =>
      item.discounts?.some(d => d.title?.toUpperCase() === code.toUpperCase())
    );

    if (applied || hasLineDiscount) {
      await loadCartDrawer(true); // this will call showCouponApplied automatically
    } else {
      if (msg) {
        msg.textContent = "Invalid or expired coupon code.";
        msg.className = "text-xs text-red-500 text-center block mt-1";
        msg.classList.remove("hidden");
      }
      applyBtn.innerText = "Apply";
      applyBtn.disabled = false;
    }
  } catch {
    if (msg) {
      msg.textContent = "Could not apply coupon. Try again.";
      msg.className = "text-xs text-red-500 text-center block mt-1";
      msg.classList.remove("hidden");
    }
    applyBtn.innerText = "Apply";
    applyBtn.disabled = false;
  }
}

// Replace the old inline listener with:
attachCouponListener();

function showCouponInput() {
  const couponBox = document.getElementById("couponInputWrapper");
  if (!couponBox) return;

  couponBox.innerHTML = `
    <label class="relative flex items-center w-full border border-gray-300 rounded-[10px] overflow-hidden px-4 py-1 cursor-text focus-within:border-gray-500 transition-colors">
            <!-- Badge Icon -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              role="img"
              width="24px"
              height="24px"
              viewBox="0 0 24 24"
              style="color: #15b79e; "
              class="iconify iconify--iconamoon"
            >
              <path fill="currentColor" fill-rule="evenodd" d="M9.765 2.998a3 3 0 0 1 4.47 0l.7.782a1 1 0 0 0 .801.332l1.05-.058a3 3 0 0 1 3.16 3.16l-.058 1.05a1 1 0 0 0 .332.8l.783.7a3 3 0 0 1 0 4.471l-.783.7a1 1 0 0 0-.332.801l.058 1.05a3 3 0 0 1-3.16 3.16l-1.05-.058a1 1 0 0 0-.8.332l-.7.783a3 3 0 0 1-4.471 0l-.7-.783a1 1 0 0 0-.801-.332l-1.05.058a3 3 0 0 1-3.16-3.16l.058-1.05a1 1 0 0 0-.332-.8l-.782-.7a3 3 0 0 1 0-4.471l.782-.7a1 1 0 0 0 .332-.801l-.058-1.05a3 3 0 0 1 3.16-3.16l1.05.058a1 1 0 0 0 .8-.332zm5.942 5.295a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414-1.414l6-6a1 1 0 0 1 1.414 0M9.5 8A1.5 1.5 0 0 0 8 9.5v.01a1.5 1.5 0 0 0 1.5 1.5h.01a1.5 1.5 0 0 0 1.5-1.5V9.5A1.5 1.5 0 0 0 9.51 8zm5 5a1.5 1.5 0 0 0-1.5 1.5v.01a1.5 1.5 0 0 0 1.5 1.5h.01a1.5 1.5 0 0 0 1.5-1.5v-.01a1.5 1.5 0 0 0-1.5-1.5z" clip-rule="evenodd"></path>
            </svg>
            <!-- Added "peer" class here -->
            <input
              type="text"
              id="couponInput"
              placeholder="Enter Coupon Code"
              class="peer w-full bg-transparent border-none outline-none text-[15px] font-bold text-gray-800 placeholder-gray-400 ml-1 py-1.5"
            >

            <!-- Added "block peer-placeholder-shown:hidden" here! -->
            <button
              id="applyCouponBtn"
              type="button"
              class="block peer-placeholder-shown:hidden shrink-0 text-black text-[12px] font-bold px-4 py-1 rounded-[6px] hover:bg-gray-800 hover:text-white transition ml-2 z-10 cursor-pointer"
            >
              Apply
            </button>
          </label>
  `;

  // 🔥 Re-bind listener AFTER DOM injection
  attachCouponListener();
}

function closeCartDrawer() {
  const drawerEl = document.getElementById("cartDrawer");
  const overlayEl = document.getElementById("cartOverlay");
  if (!drawerEl || !overlayEl) return;
  drawerEl.classList.add("translate-x-full");
  overlayEl.classList.add("hidden");
  document.body.classList.remove("overflow-hidden");
}

// Ensure functions are global for 'onclick' attributes in theme.liquid
window.openCartDrawer = openCartDrawer;
window.closeCartDrawer = closeCartDrawer;

document.addEventListener("keydown", function (event) {
  const drawerEl = document.getElementById("cartDrawer");

  if (!drawerEl || drawerEl.getAttribute("aria-hidden") !== "false") {
    return;
  }

  if (event.key === "Escape") {
    event.preventDefault();
    closeCartDrawer();
    return;
  }

  if (event.key !== "Tab") return;

  const focusableElements = Array.from(
    drawerEl.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )
  ).filter((element) => element.offsetParent !== null);

  const drawerTitle = document.getElementById("cartDrawerCountTitle");

  if (focusableElements.length === 0) {
    event.preventDefault();
    drawerTitle?.focus();
    return;
  }

  const firstElement = focusableElements[0];
  const lastElement = focusableElements[focusableElements.length - 1];
  const activeElement = document.activeElement;

  if (
    event.shiftKey &&
    (activeElement === firstElement || activeElement === drawerTitle)
  ) {
    event.preventDefault();
    lastElement.focus();
  } else if (!event.shiftKey && activeElement === lastElement) {
    event.preventDefault();
    firstElement.focus();
  }
});

function formatMoney(cents) {
  return "₹" + (cents / 100).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// Update the count badge AND Title text beautifully!
function updateHeaderCartCount(count) {
  // Update Header Bubbles
  const bubbles = document.querySelectorAll(".cart-count-bubble");
  bubbles.forEach(bubble => {
    bubble.textContent = count;
    bubble.classList.toggle("hidden", count === 0);
  });

  // Update Drawer Title
  const drawerTitle = document.getElementById("cartDrawerCountTitle");
  if (drawerTitle) {
    drawerTitle.textContent = `Your Cart (${count} Items)`;
  }
}

// Coupon logic
// document.getElementById("applyCouponBtn")?.addEventListener("click", async () => {
//   const code = document.getElementById("couponInput")?.value?.trim();
//   const msg = document.getElementById("couponMessage");
//   if (!code) return;

//   const applyBtn = document.getElementById("applyCouponBtn");
//   applyBtn.innerText = "Applying...";
//   applyBtn.disabled = true;

//   try {
//     // Step 1: Apply discount to session via cart update
//     const res = await fetch("/discount/" + encodeURIComponent(code), {
//       method: "GET",
//       headers: { "Accept": "application/json" }
//     });

//     // Step 2: Check if it was accepted by fetching cart
//     const cartRes = await fetch("/cart.js");
//     const cart = await cartRes.json();

//     // Shopify stores applied discount in cart.cart_level_discount_applications
//     const applied = cart.cart_level_discount_applications?.find(
//       d => d.title?.toUpperCase() === code.toUpperCase()
//     );

//     if (applied) {
//       msg.textContent = `✓ "${code}" applied — ${applied.value}${applied.value_type === 'percentage' ? '%' : '₹'} off`;
//       msg.className = "text-xs text-green-600 text-center block mt-1";
//       msg.classList.remove("hidden");
//     } else {
//       // Also check line item discounts
//       const hasLineDiscount = cart.items.some(item => 
//         item.discounts?.some(d => d.title?.toUpperCase() === code.toUpperCase())
//       );
      
//       if (hasLineDiscount) {
//         msg.textContent = `✓ "${code}" applied successfully`;
//         msg.className = "text-xs text-green-600 text-center block mt-1";
//         msg.classList.remove("hidden");
//       } else {
//         msg.textContent = "Invalid or expired coupon code.";
//         msg.className = "text-xs text-red-500 text-center block mt-1";
//         msg.classList.remove("hidden");
//       }
//     }

//     // Reload drawer to reflect any price changes
//     await loadCartDrawer(true);

//   } catch {
//     msg.textContent = "Could not apply coupon. Try again.";
//     msg.className = "text-xs text-red-500 text-center block mt-1";
//     msg.classList.remove("hidden");
//   } finally {
//     applyBtn.innerText = "Apply";
//     applyBtn.disabled = false;
//   }
// });

async function changeQuantity(key, newQty) {
  if (isUpdating) return;
  isUpdating = true;
  showCartLoader(); 
  try {
    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: newQty })
    });
    
    if (!res.ok) throw new Error("Failed to update quantity");
    
    await loadCartDrawer(true); 
  } catch (err) {
    console.error("Error changing quantity:", err);
    // Re-load to sync UI with state if error occurs
    await loadCartDrawer(true);
  } finally {
    isUpdating = false;
    hideCartLoader(); 
  }
}


async function loadBundleRecommendations(productId) {
  const bundleSection = document.getElementById("bundleSection");
  const bundleProducts = document.getElementById("bundleProducts");
  if (!bundleSection || !bundleProducts) return;

  try {
    // Send the first cart item's ID to Shopify's recommendation engine
    const res = await fetch(`/recommendations/products.json?product_id=${productId}&limit=4`);
    const data = await res.json();
    const products = data.products;

    if (!products || products.length === 0) {
      bundleSection.classList.add("hidden");
      return;
    }

    let html = "";
    products.forEach(product => {
      
      // Math to calculate discount percentage badge
      let discountBadge = "";
      let priceHtml = "";
      let compareAtPrice = product.compare_at_price;
      let price = product.price;

      if (compareAtPrice > price) {
        const discountPercent = Math.round(((compareAtPrice - price) / compareAtPrice) * 100);
        discountBadge = `
          <span class="bg-[#12b392] text-black text-[11px] font-black px-[4px] py-[3px] rounded-[6px] text-center w-full block whitespace-nowrap tracking-wide leading-tight shadow-sm mt-1">
            ${discountPercent}% off
          </span>`;
        priceHtml = `
          <span class="text-[12px] font-black text-[#D3D3D3] line-through tracking-wide block leading-none">${formatMoney(compareAtPrice)}</span>
          <span class="text-[16px] font-black text-[#0B1A3A] tracking-tight block mt-1 leading-none">${formatMoney(price)}</span>
        `;
      } else {
        priceHtml = `
          <span class="text-[16px] font-black text-[#0B1A3A] tracking-tight block mt-[14px] leading-none">${formatMoney(price)}</span>
        `;
      }

      // Nuuk Bundle Card HTML Design Injection
      html += `
        <div class="snap-start flex gap-3 border border-gray-200 rounded-[12px] p-2.5 w-[230px] bg-white transition hover:shadow-sm">
          
          <!-- Left: Image & Badge -->
          <div class="flex flex-col flex-shrink-0 w-[75px] items-center justify-between">
            <div class="w-full h-[75px] flex items-center justify-center">
              <img src="${product.featured_image}" alt="${product.title}" class="w-full h-full object-contain mix-blend-multiply">
            </div>
            ${discountBadge}
          </div>

          <!-- Right: Info & Add Button -->
          <div class="flex flex-col flex-1 justify-between h-full">
            <div class="min-w-0 w-full">
              <h5 class="text-[14px]! font-medium text-[#0A1A3A] line-clamp-2 leading-tight pr-1">
                ${product.title}
              </h5>
              <div class="mt-2 flex flex-col">
                ${priceHtml}
              </div>
            </div>
            
            <button class="add-to-cart-btn mt-2 border border-[#111] rounded-[8px] py-[4px] text-[13px] font-semibold text-black hover:bg-gray-50 transition w-full" data-variant-id="${product.variants[0].id}">
              + Add
            </button>
          </div>
        </div>
      `;
    });

    bundleProducts.innerHTML = html;
    bundleSection.classList.remove("hidden"); // Unhide the bundle section!

  } catch (err) {
    console.error("Failed to load recommendations:", err);
  }
}

function showCartLoader() {
  const loader = document.getElementById('cartDrawerLoader');
  if (loader) {
    loader.classList.remove('opacity-0', 'pointer-events-none');
    loader.classList.add('opacity-100', 'pointer-events-auto');
  }
}

function hideCartLoader() {
  const loader = document.getElementById('cartDrawerLoader');
  if (loader) {
    loader.classList.remove('opacity-100', 'pointer-events-auto');
    loader.classList.add('opacity-0', 'pointer-events-none');
  }
}




async function loadCartDrawer(isSilent = false) {
  if (!container) return;
  
  if (!isSilent) {
    container.innerHTML = `<div class="flex justify-center items-center py-10"><p class="text-[#7F7F7F]">Loading...</p></div>`;
  }

  try {
    const res = await fetch("/cart.js");
    const cart = await res.json();

    updateHeaderCartCount(cart.item_count);

    const subtotalEl = document.getElementById("cartDrawerSubtotal");
    const discountEl = document.getElementById("cartDrawerDiscount"); // add this element in HTML

    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(cart.total_price);
    }

    // Show discount line if applied
    if (cart.cart_level_discount_applications?.length > 0) {
      const discount = cart.cart_level_discount_applications[0];
      const savedAmount = cart.items_subtotal_price - cart.total_price;

      if (savedAmount > 0) {
        showCouponApplied(discount.title, formatMoney(savedAmount));
      }
    } else {
      showCouponInput();
    }
    const scrollableContent = document.getElementById('scrollableContent')

        if (cart.items.length === 0) {
      // ----- NEW: EMPTY STATE TRIGGER -----
      const emptyState = document.getElementById('cartEmptyState');
      const stickyFooter = document.getElementById('cartDrawerStickyFooter');
      const bundleSection = document.getElementById('bundleSection');
      
      if (emptyState) {
        emptyState.classList.remove('hidden');
        emptyState.classList.add('flex');
        scrollableContent.classList.add('hidden')
      }
      if (container) container.classList.add('hidden');
      if (stickyFooter) stickyFooter.classList.add('hidden');
      if (bundleSection) bundleSection.classList.add('hidden'); // Also hide recommendations
      
      return;
    } else {
      // ----- NEW: HIDE EMPTY STATE, SHOW CONTENT -----
      const emptyState = document.getElementById('cartEmptyState');
      const stickyFooter = document.getElementById('cartDrawerStickyFooter');
      
      if (emptyState) {
        emptyState.classList.add('hidden');
        emptyState.classList.remove('flex');
        scrollableContent.classList.remove('hidden')
      }
      if (container) container.classList.remove('hidden');
      if (stickyFooter) stickyFooter.classList.remove('hidden');
    }


    let html = "";
    cart.items.forEach((item, index) => {
      const line = index + 1;
      
      // Render Variant Pill ONLY if it exists
      let variantHtml = '';
      if (item.variant_title && item.variant_title !== 'Default Title' && item.variant_title !== 'Default') {
        variantHtml = `
           <div class="mt-2">
             <button class="flex items-center gap-1.5 border border-gray-400 rounded-md px-[10px] py-[3px] w-fit text-[11px] font-extrabold text-black hover:border-gray-600 transition">
               ${item.variant_title}
               <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M6 9l6 6 6-6"/></svg>
             </button>
           </div>
        `;
      }

      // Nuuk Inspired Cart Item UI Injection
      html += `
        <div class="flex gap-4 py-3 border-b last:border-0 border-gray-100 cart-item-row relative" data-line="${line}">
          
          <!-- Image Box -->
          <div class="w-[85px] h-[85px] bg-white rounded-[10px] flex items-center justify-center shrink-0 shadow-[0_0_0_1px_#F0F0F0]">
            <img src="${item.image}" class="w-full h-full object-contain mix-blend-multiply" alt="${item.product_title}">
          </div>
          
          <!-- Details Grid -->
          <div class="flex flex-col flex-1 relative min-h-[85px]">
             
             <!-- Top Row: Title & Price -->
             <div class="flex items-start justify-between gap-3">
               <h4 class="text-[14px]! font-medium text-black leading-snug line-clamp-3 pr-2">
                 ${item.product_title}
               </h4>
               <span class="text-[14px] font-black text-black whitespace-nowrap mt-[-2px]">
                 ${formatMoney(item.final_price)}
               </span>
             </div>
             
             <!-- Variant HTML Hook -->
             ${variantHtml}
    
            <!-- Controls (Pinned to bottom right) -->
             <div class="absolute bottom-0 right-0 flex items-center gap-1">
                
                <!-- Qty Selector -->
                <div class="flex items-center border border-gray-200 rounded-lg h-[28px] bg-gray-50/50">
                  <button class="qty-btn qty-minus w-7 h-full flex items-center justify-center text-black font-bold hover:bg-gray-200 transition text-[15px]" data-key="${item.key}" data-action="minus">
                    <span class="leading-none mb-0.5">−</span>
                  </button>
                  <span class="qty-value w-5 text-center text-[12px] font-black text-black" data-key="${item.key}">${item.quantity}</span>
                  <button class="qty-btn qty-plus w-7 h-full flex items-center justify-center text-black font-bold hover:bg-gray-200 transition text-[15px]" data-key="${item.key}" data-action="plus">
                    <span class="leading-none mb-[1px]">+</span>
                  </button>
                </div>

                <!-- Trash Icon -->
                <button class="text-black hover:text-red-500 transition flex items-center justify-center qty-btn" data-key="${item.key}" data-action="remove">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"></path><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
                </button>

             </div>

          </div>
        </div>
      `;
    });
    container.innerHTML = html;

    // ----- NEW: Trigger Shopify Recommendations dynamically! -----
    const bundleSection = document.getElementById("bundleSection");
    if (cart.items.length > 0) {
       loadBundleRecommendations(cart.items[0].product_id);
    } else {
       // Hide bundle section if cart empty
       if (bundleSection) bundleSection.classList.add("hidden");
    }

  } catch (err) {
    console.error("Error loading cart:", err);
    if (!isSilent) container.innerHTML = "Error loading cart";
  }
}

// Global click listener for drawer actions
document.addEventListener("click", async function (e) {
  const target = e.target;
  if (!target || !target.closest) return;

  const addBtn = target.closest(".add-to-cart-btn");

  // NEW: Detect the header icon or any strict cart link
  const openCartBtn = target.closest(".open-cart-btn") || target.closest('a[href="/cart"]');

  const closeBtn = target.closest("#closeCartDrawer");
  const overlayClick = target.id === "cartOverlay" || target === overlay;
  const isDrawerOpen = document.getElementById("cartDrawer")?.classList.contains("translate-x-full") === false;

  // EXPLICIT OPEN CART ACTION (from Header Icon)
  if (openCartBtn && !addBtn) {
    if (isDrawerOpen) return;
    e.preventDefault();
    loadCartDrawer();
    openCartDrawer(openCartBtn);
    return;
  }

  // EXPLICIT CLOSE ACTIONS (Prioritize these to ensure responsiveness)
  if (closeBtn || overlayClick) {
    e.preventDefault();
    closeCartDrawer();
    return;
  }

  // CLOSE WHEN CLICKING OUTSIDE DRAWER
  const drawerContent = document.getElementById("cartDrawer");
  if (isDrawerOpen && drawerContent && !drawerContent.contains(target) && !addBtn && !openCartBtn) {
    closeCartDrawer();
    return;
  }

  const qtyBtn = target.closest(".qty-btn");

  // OPTIMISTIC QUANTITY CHANGES WITH TRASH CAN SUPPORT
  if (qtyBtn) {
    e.preventDefault(); 
    if (isUpdating) return;
    const row = qtyBtn.closest('.cart-item-row');
    const key = qtyBtn.dataset.key; // 🔥 Target precisely by unique key
    const action = qtyBtn.dataset.action;
    
    const qtyElement = row ? row.querySelector('.qty-value') : null; 
    
    let newQty = 0;
    
    // Process trash removal vs standard math
    if (action === 'remove') {
      newQty = 0;
    } else if (qtyElement) {
      let currentQty = parseInt(qtyElement.textContent);
      newQty = action === 'plus' ? currentQty + 1 : currentQty - 1;
    }
    
    if (newQty < 0) return;

    // Update UI Instantly
    if (qtyElement && action !== 'remove') {
      qtyElement.textContent = newQty;
    }

    // Ghost row instantly if it's hitting 0
    if (newQty === 0 && row) {
      row.style.opacity = '0.4';
    }

    // Run the API call safely
    clearTimeout(updateTimeout);
    updateTimeout = setTimeout(() => {
      changeQuantity(key, newQty);
    }, 300); 
    
    return;
  }



  // ADD TO CART SUPPORT
  if (addBtn) {
    e.preventDefault();
    const variantId = addBtn.dataset.variantId;
    if (!variantId) return;

    try {
      const originalText = addBtn.innerText;
      addBtn.disabled = true;
      addBtn.innerText = "Adding...";

      showCartLoader(); 

      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      await loadCartDrawer();
      openCartDrawer();
      
      addBtn.disabled = false;
      addBtn.innerText = originalText;
    } catch (error) {
      console.error("Cart error:", error);
      addBtn.disabled = false;
      addBtn.innerText = "Add to Cart";
    } finally {
      hideCartLoader();
    }
  }
});

// Shopify Cart Hooks
document.addEventListener("cart:update", function (e) {
  if (e.detail && e.detail.data && e.detail.data.didError) return;
  loadCartDrawer();
  openCartDrawer();
});

document.addEventListener("cart:add", function () {
  loadCartDrawer();
  openCartDrawer();
});

document.addEventListener("DOMContentLoaded", function() {
  loadCartDrawer(true);

  // --- GLOBAL AJAX HANDLERS ---
  
  // Handle ALL AJAX forms with class 'ajax-add-to-cart'
  document.addEventListener('submit', async function (e) {
    const form = e.target.closest('.ajax-add-to-cart');
    if (!form) return;

    e.preventDefault();

    const submitBtn = form.querySelector('button[type="submit"]');
    if (!submitBtn) return;
    
    const originalText = submitBtn.innerText;

    submitBtn.innerText = 'Adding...';
    submitBtn.disabled = true;

    try {
      const formData = new FormData(form);

      await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
      });

      // Update the UI and Open Drawer
      await loadCartDrawer();
      openCartDrawer();

      // Revert button
      submitBtn.innerText = originalText;
      submitBtn.disabled = false;
    } catch (err) {
      console.error('AJAX Cart Error:', err);
      submitBtn.innerText = 'Error!';
      setTimeout(() => {
        submitBtn.innerText = originalText;
        submitBtn.disabled = false;
      }, 2000);
    }
  });

  // Handle Global Quantity Selectors
  document.addEventListener('click', function (e) {
    const minusBtn = e.target.closest('.quantity-btn-minus');
    const plusBtn = e.target.closest('.quantity-btn-plus');
    
    if (minusBtn || plusBtn) {
      const container = (minusBtn || plusBtn).closest('div');
      const qtyInput = container.querySelector('.quantity-input-field');
      if (qtyInput) {
        const currentVal = parseInt(qtyInput.value) || 1;
        if (minusBtn && currentVal > 1) {
          qtyInput.value = currentVal - 1;
        } else if (plusBtn) {
          qtyInput.value = currentVal + 1;
        }
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });
});

